// src/components/MediaUpload/MediaUpload.js
import React from 'react';

const MediaUpload = ({ onUpload, mediaFiles, setError }) => {
    const MAX_FILE_LIMIT = 5;
    const MAX_FILE_SIZE_MB = 1;
    const ALLOWED_FILE_TYPES = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "application/pdf",
        "application/msword", // .doc
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    ];
    
    const getFileCount = (files) => {
        return files.length; // Count all files, not just images
    };
    const handleFileChange = (e) => {
        console.log("handleFileChange triggered", e.target.files);
        if (e.target.files) {
            const currentFileCount = getFileCount(mediaFiles);
            const selectedFiles = Array.from(e.target.files);
            console.log("Selected files:", selectedFiles);

            const validFiles = [];
            const errors = [];

            for (let file of selectedFiles) {
                console.log("Validating file:", file.name, file.type, file.size);
                if (!ALLOWED_FILE_TYPES.includes(file.type)) {
                    errors.push(`Invalid file type: ${file.name}. Allowed types: JPG, PNG, PDF, DOC, DOCX.`);
                    continue;
                }
                if (file.size / 1024 / 1024 > MAX_FILE_SIZE_MB) {
                    errors.push(`File too large: ${file.name}. Max size: ${MAX_FILE_SIZE_MB}MB.`);
                    continue;
                }
                validFiles.push(file);
            }

            const fileCount = validFiles.length;
            const totalFileCount = currentFileCount + fileCount;
            console.log("Total file count:", totalFileCount);

            if (fileCount > MAX_FILE_LIMIT) {
                errors.push(`You cannot select more than ${MAX_FILE_LIMIT} files at a time.`);
            } else if (totalFileCount > MAX_FILE_LIMIT) {
                errors.push(`You cannot upload more than ${MAX_FILE_LIMIT} files in total.`);
            } else if (validFiles.length > 0) {
                console.log("Calling onUpload with files:", validFiles);
                setError("");
                onUpload(validFiles);
            }

            if (errors.length > 0) {
                setError(errors.join("; "));
            }
            e.target.value = '';
        }
    };

    return (
        <label className="cursor-pointer text-gray-500 hover:text-blue-500 flex items-center space-x-1 wjl1">
            <p
                className="text-gray-700 font-bold hover:text-base hover:bg-gray-200 px-3 py-1 hover:rounded-md cursor-pointer"

            >
                <i className="solid-icon-Folder-Upload" style={{ fontSize: '70px' }}></i>
            </p>
            <input
                id="media-upload-input"
                type="file"
                multiple
                accept="image/jpeg,image/png,image/jpg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
        </label>
    );
};

export default MediaUpload;
